/**
 * Wahler-Backend
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum HrToolAiCapabilityType {

    GENERATE_AND_CREATE = 'GENERATE_AND_CREATE',

    SEARCH_AND_UNDERSTAND = 'SEARCH_AND_UNDERSTAND',

    ANALYZE_AND_DETECT = 'ANALYZE_AND_DETECT',

    RECOMMEND_AND_MATCH = 'RECOMMEND_AND_MATCH',

    PREDICT = 'PREDICT',

    AUTOMATE = 'AUTOMATE',

    ACT_AGENTICALLY = 'ACT_AGENTICALLY'
}

